import React from 'react';
import { Popup } from 'react-map-gl';
import { Icons } from '../../../';
// constants
import { prefix } from '../../../../constants';
export const MapPopup = ({ latitude, longitude, altitude, closeButton = true, onClose, closeOnClick = true, children, tipSize = 0, className, anchor, offsetLeft = 0, offsetTop = 0, }) => {
    return (React.createElement(Popup, { anchor: anchor, latitude: latitude, longitude: longitude, altitude: altitude, closeButton: false, onClose: onClose, closeOnClick: closeOnClick, className: `${className} ${prefix}-map-popup`, offsetLeft: offsetLeft, offsetTop: offsetTop, tipSize: tipSize },
        closeButton && (React.createElement("button", { className: "mapboxgl-popup-close-button" },
            React.createElement(Icons, { iconName: "ic-ui-cancel-sm" }))),
        children));
};
//# sourceMappingURL=MapPopup.js.map